import { GenericService } from '../generic.service';
import { EncounterType } from '@/models';

export class EncounterTypesService extends GenericService<EncounterType> {
  endpoint = '/menicon/v1/encounter-types';
}
